import {
  Text,
  GreyGrey90,
  Image,
  Primary13Regular,
  Flex
} from '@sequencehq/core-components'
import rilletCover from './rilletCover.png'

export const RilletIntegrationDetail = () => {
  return (
    <Flex flexDirection="column" gap="20px">
      <Image
        src={rilletCover}
        width="100%"
        borderRadius="8px"
        draggable={false}
      />
      <Text {...Primary13Regular} color={GreyGrey90} lineHeight="18px">
        Integrate Sequence with Rillet to automate your invoicing and
        accounting. Push Sequence customers and products into Rillet. Sync
        invoices and credit notes automatically with bidirectional updates.
        Configure Rillet account and bank detail mappings in Sequence to ensure
        accurate revenue attribution and reconciliation.
      </Text>
    </Flex>
  )
}
